
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';
import UserMenu from './UserMenu';
import RoleBadge from './RoleBadge';
import LogoutButton from '@/components/LogoutButton';
import LanguageSelector from '@/components/LanguageSelector';

interface DesktopAuthActionsProps {
  isLoggedIn: boolean;
  userRole: any;
  isAdminOrHigher: boolean;
  isSuper: boolean;
  handleLogin: () => void;
  handleDashboard: () => void;
}

const DesktopAuthActions: React.FC<DesktopAuthActionsProps> = ({
  isLoggedIn,
  userRole,
  isAdminOrHigher,
  isSuper,
  handleLogin,
  handleDashboard
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="hidden md:flex items-center space-x-4">
      {isLoggedIn ? (
        <div className="flex items-center space-x-2">
          <RoleBadge userRole={userRole} />
          
          <UserMenu 
            userRole={userRole} 
            isAdminOrHigher={isAdminOrHigher} 
            isSuper={isSuper} 
            handleDashboard={handleDashboard}
          />

          {/* Add direct logout button for easier access */}
          <LogoutButton />
        </div>
      ) : (
        <>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={handleLogin}
          >
            {t('navLogin')}
          </Button>
          <Button 
            variant="default" 
            size="sm" 
            className="bg-synagogue-gold hover:bg-synagogue-blue text-white"
            onClick={handleLogin}
          >
            {t('navSignup')}
          </Button>
        </>
      )}
      <LanguageSelector />
    </div>
  );
};

export default DesktopAuthActions;
